var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.textBanners.length > 0),expression:"textBanners.length > 0"}]},[(_vm.$apollo.queries.bannersActive.loading)?void 0:_c('AppTextBannerCollection',{attrs:{"banners":_vm.textBanners}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }